import { http } from 'interfaces'
import { type PersonBaseBasicInformation } from 'services'

export interface UsPeopleFilterResults {
  data: PersonBaseBasicInformation[]
  page_number: number
  page_size: number
  total_pages: number
  total_items: number
}

export async function usPeopleListFilter (params: any): Promise<UsPeopleFilterResults> {
  return await http.get('/api/v1/us/people/list', {
    params: { ...params }
  }).then(value => value.data)
    .catch(() => { return { data: [], page_number: 0, page_size: 0, total_items: 0, total_pages: 0 } })
}
